import { css } from '@emotion/react';
import type { UnavailableBlockCalendarEvent } from '../../../types';

interface Props {
  event: UnavailableBlockCalendarEvent;
}
export const UnavailableBlockEvent = ({ event }: Props) => {
  return <div css={containerStyle}>{event.eventType}</div>;
};

const containerStyle = css({
  // TODO: use theme colors
  background: '#e5e7eb',
  color: '#374151',
});
